'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryForm = void 0;
const $ = require("jquery");
class EntryForm {
    constructor() {
        const self = this;
        // 確認ページから入力ページに戻った場合フォームに値を戻す
        const isBack = self.isBack();
        if (isBack) {
            self.ajaxSetFormBackValues();
        }
        // 確認ページへ
        $('#trigConfirmEntryForm').on('click', function () {
            $('.paramEntryFormErrorMessage').remove();
            const formName = $(this).data('name');
            const request = self.getFormValues(formName);
            const errorNames = self.validate(request);
            if (errorNames.length > 0) {
                return self.validation(errorNames);
            }
            const reCaptchaValue = $('#recaptchaResponse').val(); // reCAPTCHA
            self.ajaxSetValue(request, reCaptchaValue);
        });
        // 送信する
        $('#trigSubmitEntryForm').on('click', function () {
            self.ajaxSubmitEntryForm();
        });
    }
    isBack() {
        const current = location.href;
        const referrer = document.referrer;
        let isBack = true;
        if (!current.match('\/entry[\/]+')) {
            isBack = false;
        }
        if (!referrer.match('entry-confirm[\/]+$')) {
            isBack = false;
        }
        return isBack;
    }
    getFormValues(formName) {
        const textInputs = $('form[name="' + formName + '"] input[type="text"]');
        const emailInputs = $('form[name="' + formName + '"] input[type="email"]');
        const checkboxInputs = $('form[name="' + formName + '"] input[type="checkbox"]');
        const textareas = $('form[name="' + formName + '"] textarea');
        let request = {
            text: {},
            email: {},
            checkbox: {},
            textarea: {},
        };
        for (let i = 0; i < textInputs.length; i++) {
            let input = textInputs.eq(i);
            request.text[input.attr('name')] = { val: input.val(), must: input.attr('data-must') };
        }
        for (let i = 0; i < emailInputs.length; i++) {
            let input = emailInputs.eq(i);
            request.email[input.attr('name')] = { val: input.val(), must: input.attr('data-must') };
        }
        for (let i = 0; i < checkboxInputs.length; i++) {
            let input = checkboxInputs.eq(i);
            const val = input.is(':checked') ? input.val() : '';
            request.checkbox[input.attr('name')] = { val: val, must: input.attr('data-must') };
        }
        for (let i = 0; i < textareas.length; i++) {
            let input = textareas.eq(i);
            request.textarea[input.attr('name')] = { val: input.val(), must: input.attr('data-must') };
        }
        return request;
    }
    validate(request) {
        let errorNames = [];
        Object.keys(request).forEach((category) => {
            const data = request[category];
            Object.keys(data).forEach((k) => {
                const name = k;
                const val = data[k].val;
                const must = data[k].must;
                if (must == '1' && val.length == 0) {
                    errorNames.push(name);
                }
            });
        });
        return errorNames;
    }
    validation(errorNames) {
        const errorMessage = '<p class="paramEntryFormErrorMessage" style="color: #ff0000; font-size: 14px;">入力してください</p>';
        errorNames.forEach((key) => {
            $('[name="' + key + '"]').parent().append(errorMessage);
        });
        return false;
    }
    setFormBackValues(data) {
        // console.log(data);
        Object.keys(data).forEach((key) => {
            $('[name="' + key + '"]').val(data[key]);
        });
        $('input[name="accept-policy"]').prop('checked', true);
    }
    /* **************** */
    /* Ajax             */
    /* **************** */
    ajaxSetValue(request, reCaptchaValue) {
        const url = '/wp/wp-content/themes/niclab2024/ajax/set_entry_form.php';
        let D = request;
        D['recaptcha_response'] = reCaptchaValue;
        $.ajax({
            type: "POST",
            url: url,
            data: D,
            dataType: 'json',
            beforeSend: function () {
                // 実行中画面
                $('#bulletAjaxingEditing').show();
            },
            success: function (data) {
                console.log(data.error);
                if (data.error == 1) {
                    let errorMessage = '';
                    errorMessage += '<p';
                    errorMessage += ' style="text-align: center; padding: 150px 20px;"';
                    errorMessage += '>';
                    errorMessage += 'reCAPTCHAが不正な操作を中断しました';
                    errorMessage += '</p>';
                    $('#entry-form-area').html(errorMessage);
                    // 実行中画面を消す
                    $('#bulletAjaxingEditing').hide();
                }
                else {
                    location.href = '/entry-confirm';
                }
            }
        });
    }
    ajaxSetFormBackValues() {
        const self = this;
        const url = '/wp/wp-content/themes/niclab2024/ajax/set_entry_form_values.php';
        $.ajax({
            type: "POST",
            url: url,
            dataType: 'json',
            beforeSend: function () {
                // 実行中画面
                $('#bulletAjaxingEditing').show();
            },
            success: function (data) {
                self.setFormBackValues(data);
            },
            complete: function () {
                // 実行中画面を消す
                $('#bulletAjaxingEditing').hide();
                // self.ajaxing = false;
            }
        });
    }
    ajaxSubmitEntryForm() {
        const url = '/wp/wp-content/themes/niclab2024/ajax/submit_entry_form.php';
        $.ajax({
            type: "POST",
            url: url,
            dataType: 'json',
            beforeSend: function () {
                // 実行中画面
                $('#bulletAjaxingEditing').show();
            },
            success: function (data) {
                if (data.error) {
                    alert(data.error);
                    return false;
                }
                else {
                    location.href = '/entry-complete';
                }
            },
            complete: function () {
                // 実行中画面を消す
                // $('#bulletAjaxingEditing').hide();
                // self.ajaxing = false;
            }
        });
    }
}
exports.EntryForm = EntryForm;
exports.default = EntryForm;
